import { IMetaTags } from '@/models/metatags.model';

export const getMetaInitialValues = (meta: IMetaTags) => {
  return {
    description: meta?.description,
    keywords: meta?.keywords,
    title: meta?.title,
    link: meta?.link,
  };
};
